var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DepartmentOverviewCard',{attrs:{"item":_vm.item},on:{"click":_vm.showDepartment}})
}
var staticRenderFns = []

export { render, staticRenderFns }